export const CALL_NO_RESPONSE = "NOT_SELECTED";
export const CALL_CONNECTED = "CONNECTED";
export const CALL_DISCONNECTED = "DISCONNECTED";
